import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Backdrop, CircularProgress } from "@mui/material";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import {
    getDetalleLocalGiftCard,
    postCrearLocalGiftCard,
    postUpdateLocalGiftCard,
} from "../../../../api/ApiService";
import { ArrowLeft, Building2 } from "lucide-react";

function AddEmpresaGiftCardPage() {
    const [cargando, setCargando] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [loadingGuardar, setLoadingGuardar] = useState(false);

    const [nombreEmpresa, setNombreEmpresa] = useState("");
    const [direccionEmpresa, setDireccionEmpresa] = useState("");
    const [emailEmpresa, setEmailEmpresa] = useState("");
    const [telefonoEmpresa, setTelefonoEmpresa] = useState("");
    const [contactoEmpresa, setContactoEmpresa] = useState("");

    const stateToken = useSelector((state) => state.reducerGlobal.token);

    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get("mode");
    const isView = mode === "view";
    const isEdit = !!id && !isView;

    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (id && stateToken) {
            handleDetalleLocalGiftCard();
        } else if (!id) {
            setCargando(true);
        }
    }, [id, stateToken]);

    const openAlert = (type, text) => {
        setSeverity(type);
        setMensaje(text);
        setOpen(true);
    };

    const handleDetalleLocalGiftCard = () => {
        getDetalleLocalGiftCard(stateToken?.access_token, id)
            .then((response) => {
                setNombreEmpresa(response?.nombre_empresa || "");
                setDireccionEmpresa(response?.direccion_empresa || "");
                setEmailEmpresa(response?.email_empresa || "");
                setTelefonoEmpresa(response?.telefono_empresa || "");
                setContactoEmpresa(response?.contacto_empresa || "");
            })
            .catch(() => {
                openAlert("error", "Error al cargar los datos de la empresa.");
            })
            .finally(() => {
                setCargando(true);
            });
    };

    const handleGuardar = () => {
        if (
            !nombreEmpresa.trim() ||
            !direccionEmpresa.trim() ||
            !emailEmpresa.trim() ||
            !telefonoEmpresa.trim() ||
            !contactoEmpresa.trim()
        ) {
            openAlert("warning", "Todos los campos son obligatorios.");
            return;
        }

        const body = {
            nombre_empresa: nombreEmpresa,
            direccion_empresa: direccionEmpresa,
            email_empresa: emailEmpresa,
            telefono_empresa: telefonoEmpresa,
            contacto_empresa: contactoEmpresa,
        };

        setLoadingGuardar(true);

        if (isEdit) {
            postUpdateLocalGiftCard(stateToken?.access_token, body, id)
                .then(() => {
                    openAlert("success", "Empresa actualizada con exito.");
                    setTimeout(() => {
                        navigate('/app/admin/paseo-plus/locales');
                    }, 1500);
                })
                .catch(() => {
                    openAlert("error", "Error al actualizar la empresa.");
                })
                .finally(() => {
                    setLoadingGuardar(false);
                });
        } else {
            postCrearLocalGiftCard(stateToken?.access_token, body)
                .then(() => {
                    openAlert("success", "Empresa creada con exito.");
                    setNombreEmpresa("");
                    setDireccionEmpresa("");
                    setEmailEmpresa("");
                    setTelefonoEmpresa("");
                    setContactoEmpresa("");
                    setTimeout(() => {
                        navigate('/app/admin/paseo-plus/locales');
                    }, 1500);
                })
                .catch(() => {
                    openAlert("error", "Error al crear la empresa.");
                })
                .finally(() => {
                    setLoadingGuardar(false);
                });
        }
    };

    const inputClass =
        "w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200 disabled:cursor-not-allowed disabled:opacity-70";

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="mx-auto max-w-3xl">
                    {/* <div className="mb-6 flex items-center gap-4">
                        <button
                            type="button"
                            onClick={() => window.history.back()}
                            className="flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-600 shadow-sm transition hover:bg-gray-50"
                        >
                            <ArrowLeft size={15} />
                            Volver
                        </button>
                        <div>
                            <h1 className="text-2xl font-bold text-gray-800">
                                {isView ? "Detalle Empresa" : isEdit ? "Editar Empresa" : "Nueva Empresa"}
                            </h1>
                            <p className="text-sm text-gray-500">
                                {isView
                                    ? "Visualiza la informacion de la empresa."
                                    : isEdit
                                        ? "Actualiza la informacion de la empresa."
                                        : "Completa los campos para registrar una nueva empresa."}
                            </p>
                        </div>
                    </div> */}

                    {cargando ? (
                        <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
                            <div className="mb-6 flex items-center gap-3 border-b border-gray-100 pb-5">
                                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#104063]/10">
                                    <Building2 size={20} className="text-[#104063]" />
                                </div>
                                <div>
                                    <p className="font-semibold text-gray-800">
                                        {isView
                                            ? nombreEmpresa || "Empresa"
                                            : isEdit
                                                ? "Informacion de la empresa"
                                                : "Datos de la empresa"}
                                    </p>
                                    <p className="text-xs text-gray-400">Paseo Plus · GiftCard</p>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                                <div className="sm:col-span-2">
                                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Nombre empresa</label>
                                    <input
                                        type="text"
                                        value={nombreEmpresa}
                                        onChange={(e) => setNombreEmpresa(e.target.value)}
                                        disabled={isView}
                                        placeholder="Ej: Mi Empresa SA"
                                        className={inputClass}
                                    />
                                </div>

                                <div className="sm:col-span-2">
                                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Direccion</label>
                                    <input
                                        type="text"
                                        value={direccionEmpresa}
                                        onChange={(e) => setDireccionEmpresa(e.target.value)}
                                        disabled={isView}
                                        placeholder="Ej: San Lorenzo, Paraguay"
                                        className={inputClass}
                                    />
                                </div>

                                <div>
                                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Email</label>
                                    <input
                                        type="email"
                                        value={emailEmpresa}
                                        onChange={(e) => setEmailEmpresa(e.target.value)}
                                        disabled={isView}
                                        placeholder="Ej: contacto@empresa.com"
                                        className={inputClass}
                                    />
                                </div>

                                <div>
                                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Telefono</label>
                                    <input
                                        type="text"
                                        value={telefonoEmpresa}
                                        onChange={(e) => setTelefonoEmpresa(e.target.value)}
                                        disabled={isView}
                                        placeholder="Ej: 0981123456"
                                        className={inputClass}
                                    />
                                </div>

                                <div className="sm:col-span-2">
                                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Persona de contacto</label>
                                    <input
                                        type="text"
                                        value={contactoEmpresa}
                                        onChange={(e) => setContactoEmpresa(e.target.value)}
                                        disabled={isView}
                                        placeholder="Ej: Carlos Arrua"
                                        className={inputClass}
                                    />
                                </div>
                            </div>

                            <div className="mt-7 flex items-center gap-3 border-t border-gray-100 pt-5">
                                {!isView && (
                                    <button
                                        type="button"
                                        onClick={handleGuardar}
                                        className="rounded-lg bg-[#104063] px-5 py-2 text-sm font-semibold text-white transition hover:bg-[#0d3553]"
                                    >
                                        {isEdit ? "Actualizar" : "Guardar"}
                                    </button>
                                )}

                                <button
                                    type="button"
                                    onClick={() => window.history.back()}
                                    className="rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-600 transition hover:bg-gray-50"
                                >
                                    {isView ? "Volver" : "Cancelar"}
                                </button>

                               
                            </div>
                        </div>
                    ) : (
                        <div className="rounded-xl bg-white p-8 shadow-sm">
                            <div className="mb-6 h-6 w-1/3 rounded bg-gray-200 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 rounded bg-gray-200 animate-pulse" />
                                <div className="h-10 rounded bg-gray-200 animate-pulse" />
                                <div className="h-10 rounded bg-gray-200 animate-pulse" />
                                <div className="h-10 rounded bg-gray-200 animate-pulse" />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {open && (
                <div className="fixed right-4 top-4 z-[10000] max-w-sm">
                    <div
                        className={`rounded-xl border px-4 py-3 shadow-lg ${
                            severity === "success"
                                ? "border-emerald-200 bg-emerald-50 text-emerald-700"
                                : severity === "warning"
                                    ? "border-amber-200 bg-amber-50 text-amber-700"
                                    : "border-red-200 bg-red-50 text-red-700"
                        }`}
                    >
                        <div className="flex items-start justify-between gap-4">
                            <p className="text-sm font-medium">{mensaje}</p>
                            <button
                                type="button"
                                onClick={() => setOpen(false)}
                                className="text-current opacity-70 transition-opacity hover:opacity-100"
                            >
                                x
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Backdrop
                open={loadingGuardar}
                sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </HeaderCustom>
    );
}

export default AddEmpresaGiftCardPage;
